import React, { useCallback, useEffect } from 'react';
import styles from './MyEstablishments.module.css';
import { CustomList, CustomLoader, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { getEstablishments } from '../../../services/subusersLinkService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const MyEstablishments = () => {

    const { t } = useTranslation();
    const userId : number = useSelector((state: RootState) => state.auth.userId);
    
    const [isLoading, setIsLoading] = React.useState(true);
    const [establishmentsList, setEstablishmentsList] = React.useState([]);

    const handleGetUserInfos = useCallback(async () => {
        setIsLoading(true);
        
        const establishmentsList = await getEstablishments(userId);
        const formatedList = establishmentsList.map((item: any) => {
            const el: ListElementType = {
                id : item.id,
                title : item.parent.username,
                description : ''
            }

            return el;
        });
        setEstablishmentsList(formatedList);

        setIsLoading(false);
    }, [userId]);

    useEffect(() => {
        handleGetUserInfos();
    }, [handleGetUserInfos]);

    return (
        <div className={styles.container}>
            { !isLoading &&
                <>
                    <CustomTitle className={styles.title}>{t('account.my_establishments.title')}</CustomTitle>

                    <div>
                        <CustomList
                            list={establishmentsList}
                        />
                    </div>
                </>
            }

            <CustomLoader isLoading={isLoading} loaderType='skeleton' />
        </div>
    )
}

export default MyEstablishments;